import { createColumnHelper } from '@tanstack/react-table';
import React from 'react';

import {
  DataGridCell,
  L_COLUMN_WIDTH_PX,
  M_COLUMN_WIDTH_PX,
} from '@sbu/components.datagrid';

import { InsightResolutionRow, isParentResolution } from './types';

interface FlatResolution {
  id: number;
  name: string;
  description?: string | null;
  parentName?: string;
}

export const flattenResolutions = (resolutions: InsightResolutionRow[]) => {
  const result: FlatResolution[] = [];

  sortResolutions(resolutions).forEach((resolution) => {
    result.push(resolution);

    // Sort sub-resolutions.
    const subResolutions = isParentResolution(resolution)
      ? [...resolution.subResolutions].sort((a, b) =>
          a.name.localeCompare(b.name)
        )
      : [];

    // Flatten arrays.
    subResolutions.forEach((data) =>
      result.push({
        parentName: resolution.name,
        ...data,
      })
    );
  });

  return result;
};

export const sortResolutions = (resolutions: InsightResolutionRow[]) =>
  [...resolutions].sort((a, b) => a.name.localeCompare(b.name));

export const getParentResolution = (
  insightResolution?: InsightResolutionRow,
  parentResolutions?: InsightResolutionRow[]
) =>
  parentResolutions?.find(
    (resolution) => resolution.id === insightResolution?.parentId
  );

export const getParentResolutionOptions = (
  parentResolutions?: InsightResolutionRow[]
) =>
  sortResolutions(parentResolutions ?? []).map(({ id, name }) => ({
    label: name,
    value: id,
  }));

const columnHelper = createColumnHelper<InsightResolutionRow>();
export const columns = [
  columnHelper.accessor('name', {
    cell: (info) => <DataGridCell>{info.getValue()}</DataGridCell>,
    header: () => <DataGridCell>Name</DataGridCell>,
    size: M_COLUMN_WIDTH_PX,
  }),
  columnHelper.accessor('description', {
    cell: (info) => <DataGridCell>{info.getValue() || '-'}</DataGridCell>,
    header: () => <DataGridCell>Description</DataGridCell>,
    minSize: L_COLUMN_WIDTH_PX,
  }),
];
